import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { Box } from '@nike/podium';
import { MiniCardBase } from './MiniCardBase';
import { Badge } from '~/components/shadcn/badge';
export function ProjectMiniCard({ project, isFirst = false }) {
    const projectUrl = `/projects/detail/${project.handle ?? project.id}`;
    return (_jsx(Link, { to: projectUrl, className: "block hover:bg-gray-50 rounded transition-colors", children: _jsx(MiniCardBase, { title: project.name, subtitle: project.subtitle, meta: _jsxs(Box, { className: "flex gap-2", children: [project.msrp && _jsx(Badge, { variant: "secondary", children: project.msrp }), project.units && (_jsx(Badge, { variant: "secondary", children: project.units }))] }), imageSrc: project.imagePath, imageAlt: project.name, isFirst: isFirst }) }));
}
